// extracted by mini-css-extract-plugin
export default {"container":"InactiveTenantLayout_container__bocq+","content":"InactiveTenantLayout_content__RLfH7"};